import { Component } from 'react';

import { translate } from 'utils/translate';

class NotFound extends Component {
    render() {
        return (
            <div className="flex flex-col items-center justify-center w-full h-screen text-center">
                <h1>{`404 | ${translate('Not Found')}`}</h1>
                <p className="mt-4 mb-2.5">{`${translate('It looks like you were lost')}`}.</p>

                <a title={`${translate('Go home')}`} href="/home">{`${translate('Go home')}`}</a>
            </div>
        );
    }
}

export default NotFound;
